import React, { Component } from 'react';

export default class SearchSerialDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false,
      model: '',
      serial: '',
      showSerialErrorMessage: false
    };
  }

  componentDidMount() {
    this.setState({
      showDialog: this.props.showDialog
    });
  }

  closeDialog = (event) => {
    event && event.preventDefault();
    this.setState({ showDialog: false, showSerialErrorMessage: false });
    this.props.handleDialog &&
      this.props.flag &&
      this.props.handleDialog(this.props.flag, false);
  };

  /** SAME restriction as first component */
  isValidSerial = (value) => {
    const pattern = /^[A-Z]{2}\d{6}$/;
    return pattern.test(value);
  };

    handleSearch = (event) => {
    event.preventDefault();
    const { model, serial } = this.state;

    if (!this.isValidSerial(serial)) {
        this.setState({ showSerialErrorMessage: true });
        return;
    }

    this.setState({ showSerialErrorMessage: false });

    // 🔹 Call API via parent
    this.props.handleSearch &&
        this.props.handleSearch({
        modelNumber: model || undefined,
        serialNumber: serial
        });

    // 🔹 CLOSE THIS DIALOG
    this.closeDialog();
    };

  render() {
    const { showDialog, model, serial, showSerialErrorMessage } = this.state;

    return (
      <div className={"overlayDialog " + (showDialog ? "visible" : "hide")}>
        <div className="blackoutLayer"></div>

        <div className="overlayDialogWindow" style={{ width: '30em', top: 122 }}>
          <a className="closeButton" onClick={this.closeDialog}>×</a>

          <h2 className="title">SEARCH SERIAL</h2>

          <div className="dialogContent">
            <div className="serialSearchRow">
              <div className="serialField">
                <label>Model (Optional)</label>
                <input
                  type="text"
                  value={model}
                  onChange={(e) =>
                    this.setState({ model: e.target.value.toUpperCase() })
                  }
                />
              </div>

              <div className="serialField">
                <label>Serial</label>
                <input
                  type="text"
                  placeholder=""
                  value={serial}
                  maxLength={8}
                  onChange={(e) =>
                    this.setState({
                      serial: e.target.value.toUpperCase(),
                      showSerialErrorMessage: false
                    })
                  }
                />
              </div>
            </div>

            {showSerialErrorMessage && (
              <p className="red bold mt-2">
                Serial number should have 2 letters and 6 numbers.
              </p>
            )}

            <div className="textCenter mt-3">
              <a className="blueButton fontSize-10" onClick={this.handleSearch}>
                SEARCH SERIAL
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App/components/dialogs/searchSerialDialog.js